import { FC } from 'react'
import WarningIcon from '@mui/icons-material/Warning'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'

interface ErrorListProps {
  errors: string[]
}
const ErrorList: FC<ErrorListProps> = ({ errors }) => {
  const { t } = useTranslation()

  return (
    <div>
      {errors.map((errorKey, index) => (
        <div key={index}>{t(`Error.API.${errorKey}`)}</div>
      ))}
    </div>
  )
}

interface ErrorProviderTooltipProps {
  errors: string[]
}
export const ErrorProviderTooltip: FC<ErrorProviderTooltipProps> = ({ errors }) => {
  if (!errors?.length) return null
  return (
    <Tooltip title={<ErrorList errors={errors} />} placement='right' arrow>
      <WarningIcon color='warning' fontSize='small' />
    </Tooltip>
  )
}
